import moment from 'moment';

// The review-date periods of the Ratings page (CP-5220). The period narrows the table and the charts
// alike; it is kept in the URL by key, so a saved link means "the last 30 days", not fixed dates.
export const REVIEW_PERIODS = [
    { key: '7d', label: 'Last 7 days', days: 7 },
    { key: '30d', label: 'Last 30 days', days: 30 },
    { key: '90d', label: 'Last 90 days', days: 90 },
    { key: '365d', label: 'Last 12 months', days: 365 },
    { key: 'all', label: 'All time', days: null },
];
export const DEFAULT_REVIEW_PERIOD = '30d';

export const reviewPeriod = (key) => REVIEW_PERIODS.find((p) => p.key === key)
    || REVIEW_PERIODS.find((p) => p.key === DEFAULT_REVIEW_PERIOD);

// [start, end) in the viewer's zone, through the end of today, as ISO with the viewer's offset.
export const periodRange = (key, now = moment()) => {
    const { days } = reviewPeriod(key);
    if (!days) return { start: null, end: null };
    const end = moment(now).startOf('day').add(1, 'day');
    return { start: moment(end).subtract(days, 'days').format(), end: end.format() };
};

// The grid filters the period adds to the Ratings list (backend `reviewed_after` / `reviewed_before`).
export const periodFilters = ({ start, end }) => [
    ...(start ? [{ field: 'reviewed_after', value: start }] : []),
    ...(end ? [{ field: 'reviewed_before', value: end }] : []),
];

// Signed whole percent change, or null when there is nothing to compare with.
export const changePercent = (current, previous) => {
    if (previous == null || current == null || previous === 0) return null;
    return Math.round(((current - previous) / previous) * 100);
};

export const share = (part, whole) => (whole ? Math.round((part / whole) * 100) : 0);

// The block to chart: the operator's configured scale when the period has reviews on it, else the
// scale with the most reviews. The rest are only counted, never merged (5- and 10-point never mix).
export const pickScaleBlock = (scales, configuredScale) => {
    const list = scales || [];
    const primary = list.find((b) => b.scale === configuredScale) || list[0] || null;
    return { primary, others: list.filter((b) => b !== primary) };
};

export const defaultThreshold = (scale) => (scale === 10 ? 8 : 4);

export const bucketLabel = (date, bucket) => {
    const m = moment(date, 'YYYY-MM-DD');
    if (bucket === 'month') return m.format('MMM YYYY');
    if (bucket === 'week') return `Week of ${m.format('MMM D')}`;
    return m.format('MMM D');
};
